import React from 'react';
import { Dialog } from '@economic/taco';
import View from '../View/View';
import KVT from './KVT';
import { KVTModel } from './types';

interface KVTDialogProps {
    entryId: number;
    actionType: 0 | 1 | 2;
    kvtQueryData: KVTModel;
    open: boolean;
    onClose: () => void;
}

export default function KVTDialog({ entryId, actionType, kvtQueryData, open, onClose }: KVTDialogProps) {
    return (
        <Dialog draggable size="xs" open={open} onClose={onClose}>
            <Dialog.Content aria-label="">
                {({ close }) => (
                    <View>
                        <KVT entryId={entryId} actionType={actionType} initialData={kvtQueryData} close={close} />
                    </View>
                )}
            </Dialog.Content>
        </Dialog>
    );
}
